module.exports = __webpack_public_path__ + "img/b526e0e.png";